import React from 'react';
import {
  ComposedChart,
  Line,
  Area,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  ResponsiveContainer,
  ReferenceLine,
  Legend,
} from 'recharts';

// Hoisted to module scope so React doesn't re-create them on every render —
// Recharts treats prop identity changes as a full re-mount in some sub-trees.
const CHART_MARGIN = { top: 10, right: 10, left: 0, bottom: 0 };
const TICK = { fontSize: 11 };
const Y_DOMAIN = ['dataMin', 'dataMax'];
const TOOLTIP_STYLE = { borderRadius: 8, border: '1px solid #ddd', fontSize: 12 };
const LEGEND_STYLE = { fontSize: 12 };
const SUPPORT_LABEL = { value: 'Support', fontSize: 10, fill: '#16a34a' };
const RESISTANCE_LABEL = { value: 'Resistance', fontSize: 10, fill: '#dc2626' };
const priceTooltipFormatter = (value, name) => [
  value != null ? `$${Number(value).toFixed(2)}` : '—',
  name,
];

const PriceAreaChart = ({ data, indicators }) => (
  <div className="h-72" data-testid="chart-price-area">
    <ResponsiveContainer width="100%" height="100%">
      <ComposedChart data={data} margin={CHART_MARGIN}>
        <defs>
          <linearGradient id="priceFill" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#8b5cf6" stopOpacity={0.35} />
            <stop offset="100%" stopColor="#8b5cf6" stopOpacity={0} />
          </linearGradient>
        </defs>
        <CartesianGrid strokeDasharray="3 3" stroke="#eee" />
        <XAxis dataKey="date" tick={TICK} minTickGap={30} />
        <YAxis domain={Y_DOMAIN} tick={TICK} width={60} />
        <Tooltip contentStyle={TOOLTIP_STYLE} formatter={priceTooltipFormatter} />
        <Legend wrapperStyle={LEGEND_STYLE} />
        <Area type="monotone" dataKey="close" stroke="#8b5cf6" strokeWidth={2} fill="url(#priceFill)" name="Close" />
        <Line type="monotone" dataKey="sma20" stroke="#10b981" dot={false} strokeWidth={1.5} name="SMA 20" />
        <Line type="monotone" dataKey="sma50" stroke="#f59e0b" dot={false} strokeWidth={1.5} name="SMA 50" />
        {indicators?.support && (
          <ReferenceLine
            y={indicators.support}
            stroke="#22c55e"
            strokeDasharray="4 4"
            label={SUPPORT_LABEL}
          />
        )}
        {indicators?.resistance && (
          <ReferenceLine
            y={indicators.resistance}
            stroke="#ef4444"
            strokeDasharray="4 4"
            label={RESISTANCE_LABEL}
          />
        )}
      </ComposedChart>
    </ResponsiveContainer>
  </div>
);

export default PriceAreaChart;
